import { render } from "./CategoriesListCategory.vue?vue&type=template&id=e57131a2"
import script from "./CategoriesListCategory.vue?vue&type=script&lang=js"
export * from "./CategoriesListCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__